module.exports = __webpack_public_path__ + "media/images/goodbye-8ebd7ee1.png";